import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = config.workSheetApi + '/worksheet/'

export const sendMessage = (data) => {
  return axios.request({
    url: baseUrl + 'send_ws_message/',
    method: 'post',
    data: data
  })
}

export const getChatLogs = (params) => {
  return axios.request({
    url: baseUrl + 'chat_logs/',
    method: 'get',
    params: params
  })
}

export const closeChatApi = (data) => {
  return axios.request({
    url: baseUrl + 'close_chat/',
    method: 'post',
    data: data
  })
}

export const VerifyWSApi = (data) => {
  return axios.request({
    url: baseUrl + 'verity_ws/',
    method: 'post',
    data: data
  })
}

export const OverChatApi = (data) => {
  return axios.request({
    url: baseUrl + 'over_chat/',
    method: 'post',
    data: data
  })
}

export const RateApi = (data) => {
  return axios.request({
    url: baseUrl + 'rate/',
    method: 'post',
    data: data
  })
}

export const CloseWindowApi = (data) => {
  return axios.request({
    url: baseUrl + 'close_window/',
    method: 'post',
    data: data
  })
}

export const VerifyHaveChatApi = () => {
  return axios.request({
    url: baseUrl + 'verify_have_chat/',
    method: 'get'
  })
}
